import { render, staticRenderFns } from "./MaterialExamTags.vue?vue&type=template&id=6e615134&scoped=true&"
import script from "./MaterialExamTags.vue?vue&type=script&lang=js&"
export * from "./MaterialExamTags.vue?vue&type=script&lang=js&"
import style0 from "./MaterialExamTags.vue?vue&type=style&index=0&id=6e615134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e615134",
  null
  
)

export default component.exports